import React from 'react'

export const useGravatarSrc = ({ email, size = 80 }) => {
  const [hash, setHash] = React.useState('')

  React.useEffect(() => {
    const getHash = async () => {
      const trimmedEmail = email?.trim().toLowerCase()
      if (!trimmedEmail) return
      const encoder = new TextEncoder()
      const data = encoder.encode(trimmedEmail)
      const hashBuffer = await crypto.subtle.digest('SHA-256', data)
      const hashArray = Array.from(new Uint8Array(hashBuffer))
      const hashHex = hashArray
        .map(b => b.toString(16).padStart(2, '0'))
        .join('')
      setHash(hashHex)
    }
    getHash()
  }, [email])

  const gravatarUrl = hash
    ? `https://www.gravatar.com/avatar/${hash}?s=${size}&d=identicon`
    : null

  return { gravatarUrl, hash }
}
